import React from "react";
import PropTypes from "prop-types";
import "../css/ErrorMessage.css";
import BackgroundImage from "../images/404.jpg";
import ChevronLeft from "../svg/ICON_chevronLeft_light.svg";

/**
 * ErrorMessage component
 */
class ErrorMessage extends React.Component {
  static displayName = "ErrorMessage";
  static propTypes = {
    className: PropTypes.string,
    error: PropTypes.string,
    message: PropTypes.string,
  };
  static defaultProps = {
    error: "Erreur 404, il n’y a plus rien ici...",
    message:
      "La page que vous recherchez a été déplacée ou son adresse n'est pas correcte.",
  };

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "ErrorMessage";
  }

  /**
   * @override
   */
  render() {
    return (
      <div
        className={`${this.className} ${this.props.className || ""}`}
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <div className={`${this.className}__content`}>
          <div className={`${this.className}__error`}>{this.props.error}</div>
          <div className={`${this.className}__message`}>
            {this.props.message}
          </div>
          <a className={`${this.className}__goback`} href="/">
            <img src={ChevronLeft} alt="<" className="icon" />
            retourner à la page principale
          </a>
        </div>
      </div>
    );
  }
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.js